import { render, staticRenderFns } from "./SolicitudSoporteNavLink.vue?vue&type=template&id=7384b857"
import script from "./SolicitudSoporteNavLink.vue?vue&type=script&lang=js"
export * from "./SolicitudSoporteNavLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports